module.exports = __webpack_public_path__ + "static/media/take-phone.191e3b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/take-phone.png
// module id = 88
// module chunks = 1 5 6 7 8 9 10 11 13 14